export default [
	{
		start: 0.05,
		end: 3,
		text: 'Allez, ce ne sont que des messages...'
	}
]
